<div>
  <h1>{{ (egiAppContext.activeApp$ | async)?.name }}</h1>
  <p>{{ (egiAppContext.activeApp$ | async).info }}</p>
</div>
